// store/chatStore.js
import {create} from "zustand";

export const useChatStore = create((set, get) => ({
    conversations: [],
    currentConversation: null, // será la ID
    permissions: {},

    // Reemplaza todas las conversaciones (ej. al traerlas del backend)
    setConversations: (convs) => set({conversations: convs}),

    addConversation: (conv) => set((state) => ({conversations: [conv, ...state.conversations]})),

    // Selecciona la conversación actual por ID
    setCurrentConversation: (id) => set({currentConversation: id}),

    setPermissions: (perms) => set({permissions: perms}),

    hasPermission: (permission) => {
        const { permissions } = get();
        return permissions["admin"] == true || permissions[permission] == true;
    }
}));
